import styled from 'styled-components';

import {
  colorBlack200,
  colorBlack900,
  colorGrey200,
  colorWhite,
  fontFamilyPrimary,
  mediaQueryMobileSmallMax,
} from 'styles';

export const Table = styled.table`
  width: 100%;
  margin-top: 0;
  border-collapse: collapse;
  table-layout: fixed;
  font-family: ${fontFamilyPrimary};
`;

export const TableHead = styled.thead`
  background: ${colorWhite};
`;

export const HeadRow = styled.tr`
  height: 48px;
  background: ${colorWhite};
`;

export const HeadCell = styled.th`
  padding: 12px 16px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: ${colorBlack200};
  text-align: left;
  vertical-align: middle;

  @media ${mediaQueryMobileSmallMax} {
    padding: 12px 8px;
    font-size: 14px;
    line-height: 20px;
  }

  ${({ $columnCount }) =>
    $columnCount === 2
      ? `
    &:first-child,
    &:nth-child(2) {
      width: 50%;
    }
  `
      : `
    &:first-child,
    &:nth-child(2),
    &:nth-child(3) {
      width: 33.33%;
    }
  `}
`;

export const SortIconUp = styled.span`
  width: 0;
  height: 0;
  border-bottom: 4px solid ${colorGrey200};
  border-top: 4px solid transparent;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-bottom: 2px;
`;

export const SortIconDown = styled.span`
  width: 0;
  height: 0;
  border-top: 4px solid ${colorGrey200};
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: 2px;
`;

export const SortIconWrapper = styled.span`
  display: inline-flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 8px;
  height: 10px;
`;

export const SortButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  cursor: pointer;

  &:not(button) {
    cursor: default;
  }

  &:hover {
    color: ${colorBlack900};
  }

  &:not(button):hover {
    color: inherit;
  }

  &[data-sort='asc'] {
    color: ${colorBlack900};

    ${SortIconUp} {
      border-bottom-color: ${colorBlack900};
    }
  }

  &[data-sort='desc'] {
    color: ${colorBlack900};

    ${SortIconDown} {
      border-top-color: ${colorBlack900};
    }
  }
`;
